import { render, staticRenderFns } from "./u-tab-inline.vue?vue&type=template&id=64c089a9&scoped=true&"
import script from "./u-tab-inline.vue?vue&type=script&lang=js&"
export * from "./u-tab-inline.vue?vue&type=script&lang=js&"
import style0 from "./u-tab-inline.vue?vue&type=style&index=0&id=64c089a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c089a9",
  null
  
)

export default component.exports